export const PHONE_MOBILE_DISPLAY = "+971 56 526 5295";
export const PHONE_MOBILE_TEL = "tel:+971565265295";
export const PHONE_LANDLINE_DISPLAY = "04-2676374";
export const PHONE_LANDLINE_TEL = "tel:+97142676374";
export const ADDRESS = "Al Nazriya Building, Damascus Street, Al Qusais, Dubai";
export const WHATSAPP_BOOKING_URL =
  "https://wa.me/971565265295?text=Hello%20Her%20Styles%20Ladies%20Salon%2C%20I%20would%20like%20to%20book%20an%20appointment.";
export const MAP_EMBED_URL =
  "https://www.google.com/maps?q=Al%20Nazriya%20Building%2C%20Damascus%20Street%2C%20Al%20Qusais%2C%20Dubai&z=16&output=embed";

export const INSTAGRAM_URL = "https://www.instagram.com/herstyles_salon_26";

export const IMAGES = {
  hero: "/salon/salon-3.jpg",
  quote: "/salon/salon-2.jpg",
  aboutMain: "/salon/salon-1.jpg?v=2",
  aboutSecondary: "/salon/salon-2.jpg",
};
